import { withResetState } from "store/hocs";

import { resultsConstants } from "./results.constants";
import { merchantListConstants } from "../../merchantList/merchantList.constants";

var initialState = {
	financialsLoading: false,
	bankBalanceLoading: false,
	loading: false,
	error: null,
	financials: [],
	bankBalances: [],
};

function resultsTabs(state = initialState, action) {
	switch (action.type) {
		case merchantListConstants.RESET_MERCHANT_INFO_STATE:
			return {
				...initialState,
			};

		case resultsConstants.GET_FINANCIALS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case resultsConstants.GET_FINANCIALS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				financials: action.financials,
			};
		case resultsConstants.GET_FINANCIALS_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case resultsConstants.GET_BANK_BALANCES_REQUEST:
			return {
				...state,
				bankBalanceLoading: true,
			};
		case resultsConstants.GET_BANK_BALANCES_SUCCESS:
			return {
				...state,
				bankBalanceLoading: false,
				bankBalances: action.bankBalances,
			};
		case resultsConstants.GET_BANK_BALANCES_ERROR:
			return {
				...state,
				bankBalanceLoading: false,
				error: action.error,
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(resultsTabs);
